import * as React from 'react';
import { AppSetting } from 'dependencies/appsettings';
import { Link } from 'react-router-dom';
import { routeConstants } from 'app/routes/route-constants';
import { FaSitemap } from 'react-icons/fa';
import { CodetableItemContentProps } from 'app/area/codetable/list/list-items/types';
import { CodetableItemLoader } from 'app/area/shared/codetable/item/codetable-item-loader';
import { DisabledTag } from 'app/area/codetable/common/disabled-tag/disabled-tag';
import { renderLine } from 'app/area/shared/codetable/list-item/list-item-lines';
import { OptionColor } from 'ui/common/select/option/option-color';
import { OptionIcon } from 'ui/common/select/option/option-icon';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeActionType } from 'app/area/codetable/item/types';
import { isDisabled } from 'app/infrastructure/data/date';
import styles from './codetable-item-content.scss';

export const CodetableItemContent = ({ codeItem, isHierarchyMode, hierarchyMetadata, translation,
  refetching, treeDepthLevel, breadcrumbs, deletingCodeItem }: Partial<CodetableItemContentProps>) => {

  const contentClass = !isHierarchyMode ? styles.content : styles.hierarchyContent;
  const hasSequence = isDefinedIncludingZero(codeItem.sequence);

  return (
    <Link
      to={routeConstants.codetableAdministrationCodeFor(breadcrumbs, codeItem.id, CodeActionType.Edit)}
      className={`${styles.container} ${deletingCodeItem ? styles.disabled : ''}`}>
      {isHierarchyMode
        ? renderLine(hierarchyMetadata, treeDepthLevel)
        : null}
      <div className={contentClass}>
        <div className={styles.leftSide}>
          <div className={styles.leftSideColumn}>
            {codeItem.icon ? <OptionIcon iconUrl={`${AppSetting.ApplicationUrl}${codeItem.icon}`} /> : null}
            {isDefinedIncludingZero(codeItem.colour) ? <OptionColor color={codeItem.colour} /> : null}
            <span>
              {codeItem.description}
              <span className={styles.codeElement}>
                #{codeItem.id}
              </span>
              {!!codeItem.childrenCount && isHierarchyMode &&
                <span className={styles.codeElement}>
                  <FaSitemap />&nbsp;{codeItem.childrenCount}
                </span>
              }
            </span>
            {(refetching || deletingCodeItem) && <CodetableItemLoader />}
          </div>
        </div>
        {(hasSequence || isDisabled(codeItem.disabled) || isDisabled(codeItem?.node?.disabled))
          && <div className={`${styles.rightSide} 
          ${hasSequence
              ? (isHierarchyMode ? styles.rightSideSequenceHierarchy : styles.rightSideSequenceFlat)
              : (isHierarchyMode ? styles.rightSideHierarchy : styles.rightSideFlat)}`}>
            {hasSequence
              ? <div className={styles.leftSideColumn}>
                <div className={styles.defaultColumn}>{codeItem.sequence}</div>
              </div>
              : null}
            <DisabledTag
              className={hasSequence ? styles.disabledTagSequence : styles.disabledTag}
              codeItem={codeItem}
              translation={translation} />
          </div>}
      </div>
    </Link>
  );
};
